import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { MerchantPaymentRequestDetailContent } from './MerchantPaymentRequestDetailContent';

export async function generateStaticParams() {
    return [];
}

export default function MerchantPaymentRequestDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <MerchantPaymentRequestDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
